import { Apollo } from 'src/gql/generated';

/** What each skill scope is called wherever a skill's audience is shown. */
export const SKILL_SCOPE_LABELS = {
  [Apollo.AgentSkillScope.Community]: 'Community',
  [Apollo.AgentSkillScope.Org]: 'Organization',
  [Apollo.AgentSkillScope.Personal]: 'Private',
} satisfies Record<Apollo.AgentSkillScope, string>;
